import { module } from 'stereomodularjs';
import modularLoad from '../utils/load';
import { html } from '../utils/environment';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        window.scrollTo(0, 0);

        this.load = new modularLoad({
            enterDelay: 600
        });


        // On link click
        this.load.on('loading', (transition, oldContainer) => {
            classRemove(document.querySelector('html'), 'is-first-load')
            classRemove(document.querySelectorAll('.has-nav-open'), 'has-nav-open')
            classRemove(document.querySelectorAll('.has-search-open'), 'has-search-open')
            classRemove(document.querySelectorAll('.has-overlay-open'), 'has-overlay-open')
            classAdd(document.querySelector('html'), 'is-changing-page')
            this.currentClass = 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace');
        });

        // On new container enter
        this.load.on('loaded', (transition, oldContainer, newContainer) => {
            classRemove(document.querySelector('body'), this.currentClass)
            this.call('destroy', oldContainer, 'app');
        });

        // On old container exit
        this.load.on('ready', (transition, newContainer) => {
            this.call('update', newContainer, 'app');
            classAdd(document.querySelector('html'), 'is-loaded')
            classRemove(document.querySelector('html'), 'is-changing-page')
            classAdd(document.querySelector('html'), 'dom-is-loaded')
            classAdd(document.querySelector('body'), 't-' + document.querySelector('.js-scroll').getAttribute('data-namespace'))
            console.log('ADD CLASS CURRENT PAGE : t-' + document.querySelector('.js-scroll').getAttribute('data-namespace'));
        });
    }

    goTo(obj) {
        this.load.goTo(obj.url, obj.transition);
    }

    destroy() {
        this.modularLoad.destroy();
    }
}
